// Initialize the Svelte app and inject it in the DOM
import App from './App.svelte'
import {auth} from './firebase.js'
import {run} from './i18n/i18n.js'
import {isUserRegistered} from './userdata.js'

run()

setTimeout(() => {
  document.documentElement.classList.add('loaded');
}, 230);

const app = new App({
  target: document.body
})

export default app
